import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE, PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawSummary(doc, summary, grandTotal,) {
  // doc.setFontSize(14);
  //doc.setFont("helvetica", "bold");
  // doc.text("CALCULATION SUMMARY ", 14, 20);
 // console.log ("Summery Data" , grandTotal);




 autoTable(doc, {
  startY: doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 10
    : 120,

  ...PDF_TABLE_STYLE,

  theme: "grid",
  tableWidth: 180,

  head: [
    ["", "Allocation Head", "OC/L (PU-34)", "Distribution", "OC/S (PU-35)"]
  ],

  body: [
    ["Mechanical Department", "06-275", format(grandTotal.mechanical.C*.55), "55%", format(grandTotal.mechanical.D*.55)],
    ["", "06-277", format(grandTotal.mechanical.C*.45), "45%", format(grandTotal.mechanical.D*.45)],
    ["", "Total", format(grandTotal.mechanical.C), "", format(grandTotal.mechanical.D)],
  ],

  styles: {
    fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING1,
    textColor:PDFCOLORSHEME.BODY_TEXT_COLOR,
  },

  headStyles: {
    fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING1,
    textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING1,
    fontStyle: "bold",
    halign: "center",
  },

  columnStyles: {
    0: {
      halign: "center",
      cellWidth: 40,
    },
    1: {
      halign: "center",
      cellWidth: 35,
    },
    2: {
      halign: "right",
      cellWidth: 35,
    },
    3: {
      halign: "center",
      cellWidth: 35,
    },
    4: {
      halign: "right",
      cellWidth: 35,
    },
  },

  didParseCell: function (data) {
    // Merge first column across 3 rows
    if (data.section === "body" && data.column.index === 0) {
      if (data.row.index === 0) {
        data.cell.rowSpan = 3;
        data.cell.styles.halign = "center";
        data.cell.styles.valign = "middle";
      } else {
        data.cell.text = [];
      }
    }
  },
});


 autoTable(doc, {
  startY: doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 10
    : 120,

  ...PDF_TABLE_STYLE,

  theme: "grid",
  tableWidth: 180,

  head: [
    ["", "Allocation Head", "OC/L (PU-34)", "Distribution", "OC/S (PU-35)"]
  ],

  body: [
    ["Electrical Department", "06-591", format(grandTotal.electrical.C*.5), "50%", format(grandTotal.electrical.D*.5)],
    ["", "06-592", format(grandTotal.electrical.C*.5), "50%", format(grandTotal.electrical.D*.5)],
    ["", "Total", format(grandTotal.electrical.C), "", format(grandTotal.electrical.D)],
  ],

  styles: {
    fontSize: PDFCOLORSHEME.FONT_SIZE_SUMMERY_HEADING1,
    textColor:PDFCOLORSHEME.BODY_TEXT_COLOR,
  },

  headStyles: {
    fillColor: PDFCOLORSHEME.BACK_COLOR_SUMMERY_HEADING1,
    textColor: PDFCOLORSHEME.FONT_COLOR_SUMMERY_HEADING1,
    fontStyle: "bold",
    halign: "center",
  },

  columnStyles: {
    0: {
      halign: "center",
      cellWidth: 40,
    },
    1: {
      halign: "center",
      cellWidth: 35,
    },
    2: {
      halign: "right",
      cellWidth: 35,
    },
    3: {
      halign: "center",
      cellWidth: 35,
    },
    4: {
      halign: "right",
      cellWidth: 35,
    },
  },

  didParseCell: function (data) {
    // Merge first column across 3 rows
    if (data.section === "body" && data.column.index === 0) {
      if (data.row.index === 0) {
        data.cell.rowSpan = 3;
        data.cell.styles.halign = "center";
        data.cell.styles.valign = "middle";
      } else {
        data.cell.text = [];
      }
    }
  },
});
  
}

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}